var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
// icons
import OnboardPopupDoc from "@frameworks/shared-library/assets/images/features/Markets/Pms/onboard-popup-doc.svg";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/OnboardPopup/onboard-popup.scss";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import { categoryWiseData } from "@frameworks/pmsjourney/utils";
var OnboardPopup = function (_a) {
    var setOnboardPopup = _a.setOnboardPopup, onClickContinue = _a.onClickContinue, productName = _a.productName, data = _a.data;
    //
    var _b = __read(useState(false), 2), checked = _b[0], setChecked = _b[1];
    var subCategoryId = useSelector(function (state) { return state.markets.AifPms; }).subCategoryId;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var name = categoryWiseData(subCategoryId).name;
    var handleCheckboxChange = useCallback(function () {
        setChecked(!checked);
    }, [checked]);
    var handleClosePopup = useCallback(function () {
        setOnboardPopup && setOnboardPopup();
    }, [setOnboardPopup]);
    var handleContinue = useCallback(function () {
        onClickContinue && onClickContinue(checked);
    }, [checked, onClickContinue]);
    return (React.createElement("div", { className: "popup-container modal-lg" },
        React.createElement("div", { className: "align-self-end cursor-pointer", onClick: handleClosePopup },
            React.createElement("i", { className: "edel-icon-close d-flex justify-content-center align-items-center text-han-blue" })),
        React.createElement("img", { src: OnboardPopupDoc, alt: "onboard-popup-doc" }),
        React.createElement("div", { className: "d-flex flex-column gap-3 align-content-center" },
            React.createElement("h2", { className: "popup-header DMSansM_24_500" },
                "Hi ", profileData === null || profileData === void 0 ? void 0 :
                profileData.empName,
                "! Ready to place your first ",
                productName,
                " ",
                "order?"),
            React.createElement("p", { className: "popup-subheader DMSan_14_500" }, "How it works in 3 simple steps:")),
        React.createElement("div", { className: "flex flex-column" },
            React.createElement("div", { className: "steps-container" }, data.map(function (_a, index) {
                var img = _a.img, title = _a.title, description = _a.description, details = _a.details;
                return (React.createElement("div", { className: "step", key: index },
                    React.createElement("img", { src: img, alt: "step-".concat(index + 1), className: "step-icon" }),
                    React.createElement("div", { className: "d-flex flex-column gap-2" },
                        React.createElement("h3", { className: "step-title m-0 DMSansNormal_12_400" }, title),
                        React.createElement("p", { className: "step-description m-0 DMSanM_14_500" }, description),
                        React.createElement("p", { className: "DMSanN_14_300 txt_midnight-blue-shade3" }, details))));
            })),
            React.createElement(GenericCheckbox, { customLabel: "Do not show this again", checkboxType: "han-blue", checkboxProps: {
                    checked: checked,
                    onChange: handleCheckboxChange,
                } })),
        React.createElement(EdButton, { onClick: handleContinue, btnTyp: "tomato", value: "Continue", className: "rounded-pill DMSans_16_500 px-5 py-2", slim: true })));
};
export default OnboardPopup;
